import React from 'react';
import {
  Box,
  useTheme,
} from '@mui/material';
import { Logo } from '../widgets/Logo';

interface SplashScreenProps {
  showSpinner?: boolean;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ showSpinner = false }) => {
  const theme = useTheme();

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: theme.palette.background.default,
      gap: 3,
    }}>
      <Logo 
        size="xlarge" 
        variant="default" 
        state={showSpinner ? "fast-blink" : "animated"}
      />
    </Box>
  );
};

export default SplashScreen; 